// qui generiamo un hook che combina i POI statici con quelli live, e fornisce un modo semplice per accedere al POI attivo (quello del modal)

import { useEffect, useState } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { firestore } from '@/firebase/config';
import { isPOINullMetaType, type POI, type POIType } from '@inloco/shared';

export function useLiveModalPoi(
    poiId: string | null,
    appSegmentId: string | null,
    isModalOpen = true
) {
    const [livePoi, setLivePoi] = useState<POI | null>(null);

    useEffect(() => {
        if (!appSegmentId || !poiId || !isModalOpen) return;

        const poiDocRef = doc(firestore, 'apps', appSegmentId, 'pois', poiId);

        const unsub = onSnapshot(poiDocRef, (snap) => {
            if (!snap.exists()) {
                setLivePoi(null);
                return;
            }

            const raw = snap.data() as any;
            const type = raw.type as POIType;

            const meta = isPOINullMetaType(type) ? null : raw.meta;

            const updated = {
                ...raw,
                meta,
                id: snap.id,
            } as POI;

            setLivePoi(updated);
        });

        return () => {
            unsub();
        };
    }, [appSegmentId, poiId, isModalOpen]);

    return isModalOpen ? livePoi : null;
}